export enum FreelancingExperienceId {
    STARTING = 'STARTING',
    INTERMEDIATE = 'INTERMEDIATE',
    EXPERT = 'EXPERT',
}

export type FreelancingExperience = {
    id: FreelancingExperienceId;
    title: string;
    illustration: string;
};
